export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Regular.ttf?7e873d3833eb108a0758be45cd29e907";